import Constants from '@/constants'

export const getBrowserVersion = () => {
  var userAgentString = window.navigator.userAgent.toLowerCase()

  switch (true) {
    case userAgentString.indexOf('edge') > -1:
      return 'edge'
    case userAgentString.indexOf('edg') > -1:
      return 'chromium edge'
    case userAgentString.indexOf('opr') > -1 && !!window.opr:
      return 'opera'
    case userAgentString.indexOf('chrome') > -1 && !!window.chrome:
      return 'chrome'
    case userAgentString.indexOf('trident') > -1:
      return 'ie'
    case userAgentString.indexOf('firefox') > -1:
      return 'firefox'
    case userAgentString.indexOf('safari') > -1:
      return 'safari'
    default:
      return 'other'
  }
}

export const isNedbankPayAcquirer = (code) =>
  code === Constants.acquirerCodes.NedbankPay

export const isCapitecPayAcquirer = (code) =>
  code === Constants.acquirerCodes.CapitecPay

export const isAbsaPayAcquirer = (code) =>
  code === Constants.acquirerCodes.AbsaPay

export const isOpenBankingAcquirer = (code) =>
  isNedbankPayAcquirer(code) ||
  isCapitecPayAcquirer(code) ||
  isAbsaPayAcquirer(code)

export const isRequest = (message) => !!message.requestType

export const buildInstruction = (message, transactionId) => {
  return {
    messageId: message.identifier,
    message: message.message,
    instructionType: message.instructionType,
    options: message.options,
    transactionId,
    isProcessing: isNotUndefinedOrNull(message.isProcessing)
      ? message.isProcessing
      : false,
  }
}

export const buildRequest = (message, transactionId) => {
  return {
    messageId: message.identifier,
    message: message.message,
    requestType: message.requestType,
    options: message.options,
    transactionId,
    isProcessing: isNotUndefinedOrNull(message.isProcessing)
      ? message.isProcessing
      : false,
  }
}

export const isNotUndefined = (prop) => prop !== undefined

export const isNotNull = (prop) => prop !== null

export const isNotUndefinedOrNull = (prop) => {
  return isNotUndefined(prop) && isNotNull(prop)
}

export const isStringSet = (prop) => {
  return prop !== '' && isNotUndefinedOrNull(prop)
}

export const toGuid = (nFormatTransactionId) => {
  if (nFormatTransactionId.length !== 32) {
    const error = new Error(`Invalid GUID format : ${this.$route.fullPath}`)
    this.$handleException({ error })
  }

  return `${nFormatTransactionId.substr(0, 8)}-${nFormatTransactionId.substr(
    8,
    4
  )}-${nFormatTransactionId.substr(12, 4)}-${nFormatTransactionId.substr(
    16,
    4
  )}-${nFormatTransactionId.substr(20)}`
}

export const toUpperCaseObject = (lowerCase) => {
  const upperCase = {}
  Object.keys(lowerCase).forEach((key) => {
    upperCase[key.toUpperCase()] = lowerCase[key]
  })

  return upperCase
}

export const isBoolean = (prop) => {
  return typeof prop === 'boolean'
}

export const isPostTransactionScreen = (routeName) => {
  return (
    routeName === 'completed' ||
    routeName === 'cancelled' ||
    routeName === 'error'
  )
}

export const isTransactionCompletedStatus = (status) => {
  const completedStatuses = ['COMPLETED', 'CANCELLED', 'FAILED', 'EXCEPTION']

  return completedStatuses.includes(status)
}

export const maskInput = (val) => {
  let maskedInput = ''
  for (let i = 0; i < val.length; i++) {
    maskedInput += i > 1 && i < 9 ? '*' : val.split('')[i]
  }
  return maskedInput
}

export const toCamelCase = (str) => {
  return str.replace(/^([A-Z])/, (_, letter) => letter.toLowerCase())
}

export const convertKeysToCamelCase = (input) => {
  if (Array.isArray(input)) {
    return input.map(convertKeysToCamelCase)
  }

  if (input !== null && typeof input === 'object' && !(input instanceof Date)) {
    const result = {}
    for (const key in input) {
      if (Object.hasOwn(input, key)) {
        const camelKey = toCamelCase(key)
        result[camelKey] = convertKeysToCamelCase(input[key])
      }
    }
    return result
  }

  return input
}
